module.exports = __webpack_public_path__ + "app-static/img/2.9c848136.png";